export default {
    primary: '#A2E4F4',
    primaryDark: '#3F8291',
    secondary: '#12161C',
    secondaryLight: '#1B2028',
    accent: '#CADEFF'
}
